//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { ProgramProjectMismatchMessage } from "./program-project-mismatch-message";
import { PresenterType } from "@app/shared";

@PresenterType({
  model: ProgramProjectMismatchMessage,
})
@Component({
  selector: "program-project-mismatch-message",
  standalone: false,
  templateUrl: "./program-project-mismatch-message.component.html",
  styleUrl: "./program-project-mismatch-message.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramProjectMismatchMessageComponent {
  public data: WritableSignal<ProgramProjectMismatchMessage>;

  constructor() {
    this.data = signal<ProgramProjectMismatchMessage>(null);
  }
}
